import {
  FS_CONTEXTS_LISTED,
  FS_DOCUMENTS_LISTED,
  FS_DOCUMENT_CREATED,
  FS_DOCUMENT_UPDATED,
  FS_CONTEXT_CREATED,
  FS_CONTEXT_UPDATED,
  FS_DOCUMENT_DELETED
} from "../actions/types";

/**
 * Reduces incoming FS actions to a new state
 *
 * @param {*} state
 * @param {*} action
 */
export default function fs(state = {}, action = {}) {
  switch (action.type) {
    /**
     * Replaces the contexts list with the one received
     * from the server
     */
    case FS_CONTEXTS_LISTED:
      return { ...state, contexts: action.contexts };
    /**
     * Sets the documents list for a specific context
     * with the one received from the server
     */
    case FS_DOCUMENTS_LISTED: {
      const documents = state.documents || {};
      documents[action.inContext] = action.documents;
      return { ...state, documents };
    }
    /**
     * Adds a newly created document
     */
    case FS_DOCUMENT_CREATED: {
      const documents = state.documents || {};
      if (!documents.hasOwnProperty(action.inContext))
        documents[action.inContext] = [];

      documents[action.inContext].push(action.document);
      return {
        ...state,
        documents,
        currentContext: action.inContext,
        currentDocument: action.document.id
      };
    }
    /**
     * Adds a newly created context
     */
    case FS_CONTEXT_CREATED: {
      const contexts = state.contexts || [];
      contexts.push(action.context);
      return { ...state, contexts };
    }
    /**
     * Updates an existing context that has changed
     */
    case FS_CONTEXT_UPDATED: {
      const contexts = state.contexts || {};
      const identifier = action.context.id;

      const newContexts = contexts.map(context => {
        if (context.id === identifier) {
          return action.context;
        }
        return context;
      });
      return { ...state, contexts: newContexts };
    }
    /**
     * Updates an existing file that has changed
     */
    case FS_DOCUMENT_UPDATED: {
      const documents = state.documents || {};
      const context = action.document.contextIdentifier;

      if (documents.hasOwnProperty(context)) {
        documents[context] = documents[context].map(document => {
          if (document.id === action.document.id) {
            return action.document;
          }
          return document;
        });
      }
      return { ...state, documents };
    }
    /**
     * Removes a deleted document
     */
    case FS_DOCUMENT_DELETED: {
      const documents = state.documents || {};
      const context = action.context;

      if (documents.hasOwnProperty(context)) {
        documents[context] = documents[context].filter(document => {
          if (document.id === action.identifier) {
            return false;
          }
          return document;
        });
      }
      return { ...state, documents };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fs.js